var _path, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgVector(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1130,
    height: 768,
    viewBox: "0 0 1130 768",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3.36598 141.522C4.70276 114.425 12.4328 88.8732 25.8938 67.0546C39.3548 45.2361 58.1455 27.8016 80.6561 16.2448C103.167 4.68801 128.726 -0.646578 155.145 0.698049C181.564 2.04268 208.054 10.0265 232.347 23.9654L1074.96 534.817C1093.5 547.138 1108.57 564.717 1118.08 585.12C1127.59 605.523 1131.07 627.74 1128.04 648.693C1125 669.647 1115.61 688.3 1101.15 702.069C1086.7 715.839 1067.9 724.043 1047.35 725.546C1045.88 725.302 522.848 746.795 522.39 746.837L0.177627 767.878L3.36598 141.522Z",
    fill: "url(#paint0_radial_7_3624)",
    fillOpacity: 0.5
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_7_3624",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(232.138 298.806) rotate(7.08274) scale(594.581 409.103)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#47A432"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#47A432",
    stopOpacity: 0
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVector);
export default __webpack_public_path__ + "static/media/Vector.668aae0fbf8ef3e9592e6680e98b56d8.svg";
export { ForwardRef as ReactComponent };